export enum ParametroTipoResultado {
  agenciaNucleo = 'agenciaNucleo',
  agencia = 'agencia',
  evento = 'evento',
}
